import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { I18NService } from '@ebw-monorepo/i18n-translate';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  itemsPerPageLabel = 'Items per page';
  nextPageLabel = 'Next page';
  previousPageLabel = 'Prev page';
  lastPageLabel = 'Last page';
  firstPageLabel = 'First page';
  rangePagesLabel = 'Page {{currPage}} of {{totPages}}';

  constructor(private translateService: I18NService) {
    super();
    this.itemsPerPageLabel = this.translateService.getTranslateParameter('list.items_per_page_label');
    this.nextPageLabel = this.translateService.getTranslateParameter('list.next_page_label');
    this.previousPageLabel = this.translateService.getTranslateParameter('list.previous_page_label');
    this.lastPageLabel = this.translateService.getTranslateParameter('list.last_page_label');
    this.firstPageLabel = this.translateService.getTranslateParameter('list.first_page_label');
    this.rangePagesLabel = this.translateService.getTranslateParameter('list.range_pages_label');
  }

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    let totPages = Math.ceil(length / pageSize);
    if (length === 0 || pageSize === 0) {
      return this.rangePagesLabel.replace('{{currPage}}', String(1)).replace('{{totPages}}', String(totPages));
    }

    return this.rangePagesLabel.replace('{{currPage}}', String(page + 1)).replace('{{totPages}}', String(totPages));
  };
}
